import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import IconButton from "@mui/material/IconButton";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import { Tooltip } from "@mui/material";
import {
  EditPlan,
  PlanImport,
  DeletePlan,
} from "../../../assets/RiskManagementIcon";
import {
  deleteIncidentResponsePlaybook,
  downloadIncidentResponsePlaybook,
  fetchIncidentResponsePlaybookDetails,
  updateIncidentResponsePlaybook,
} from "../helper";
import { useIncidentResponsePlaybookContext } from "../../../context/IncidentResponsePlaybook/IncidentResponsePlaybookContext";
import RichTextBoxTabPanel from "../../../components/RichTextBoxEditerTabs";
import { useUserContext } from "../../../context/auth/UserContext";
import { useAccessRights } from "../../../utils/useAccessRights";
import { getUserName } from "../../../helper/helper";

export const DisplayResponsePlaybook = (props: { refreshList: () => void }) => {
  const navigate = useNavigate();
  const incidentResponsePlayBookAccess = useAccessRights(
    "Incident Response PlayBook"
  );

  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });

  const { userId, companyProfileID } = useUserContext();
  const {
    playbookDetails,
    setPlaybookDetails,
    selectedIncidentResponsePlaybook,
  } = useIncidentResponsePlaybookContext();

  const tabDetalis = [
    {
      label: "Preparation",
      key: "preparation",
      id: "tab-preparation",
      editerValue: playbookDetails?.preparation
        ? playbookDetails.preparation
        : "",
    },
    {
      label: "Detection",
      key: "detection",
      id: "tab-detection",
      editerValue: playbookDetails?.detection ? playbookDetails.detection : "",
    },
    {
      label: "Analysis",
      key: "analysis",
      id: "tab-analysis",
      editerValue: playbookDetails?.analysis ? playbookDetails.analysis : "",
    },
    {
      label: "Containment",
      key: "containment",
      id: "tab-containment",
      editerValue: playbookDetails?.containment
        ? playbookDetails.containment
        : "",
    },
    {
      label: "Eradication",
      key: "eradication",
      id: "tab-eradication",
      editerValue: playbookDetails?.eradication
        ? playbookDetails.eradication
        : "",
    },
    {
      label: "Recovery",
      key: "recovery",
      id: "tab-recovery",
      editerValue: playbookDetails?.recovery ? playbookDetails.recovery : "",
    },
    {
      label: "Reporting",
      key: "reporting",
      id: "tab-reporting",
      editerValue: playbookDetails?.reporting ? playbookDetails.reporting : "",
    },
  ];

  const displayEditPlaybook = async (details: any) => {
    const date = new Date();
    const payload = [
      {
        ...details,
        isEditedByUser: true,
        isEditedByUserId: userId + "",
        updateBy: userId,
        updateDate: date,
      },
    ];

    const resUpdate = await updateIncidentResponsePlaybook(payload);
    if (resUpdate.succeeded === true) {
      navigate("/incident-response-playbook-form");
    }
  };

  const handleCloseDialog = () => {
    // console.log("handleCloseDialog", dialogState);
    if (dialogState.title === "Success") {
      props.refreshList();
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    } else {
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    }
  };

  const handleEditPlaybook = async () => {
    const res = await await fetchIncidentResponsePlaybookDetails(
      selectedIncidentResponsePlaybook[0].playbookID
    );
    // console.log("handleEditPlan plan", res);
    if (res.isEditedByUser && parseInt(res.isEditedByUserId) !== userId) {
      let userName = await getUserName(res.isEditedByUserId);
      setDialogState({
        title: "Info",
        body: `You are unable to modify this playbook because ${userName} has already begun editing it.`,
        action: "Ok",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      displayEditPlaybook(res);
    }
  };

  const confirmDelete = () => {
    setDialogState({
      title: "Confirmation",
      body: `Are you sure you want to delete <strong>${playbookDetails.playbookName}</strong??`,
      action: "Delete",
      actionCancel: "Cancel",
      openDeleteConfirmationDialog: true,
      openSuccessDialogBox: false,
    });
  };

  const handleDeletePlaybook = async () => {
    setPlaybookDetails({});
    setDialogState(() => ({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    }));

    const res = await deleteIncidentResponsePlaybook(
      userId,
      playbookDetails.playbookID
    );
    // console.log("handleDeletePlaybook res", payload, res);
    if (res.succeeded === true) {
      setDialogState({
        title: "Success",
        body: "Playbook successfully deleted",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }
  };

  const fetchPlaybookDetails = async () => {
    const res = await fetchIncidentResponsePlaybookDetails(
      selectedIncidentResponsePlaybook[0].playbookID
    );
    // console.log("handleDeletePolicy res", res);

    if (res) {
      setPlaybookDetails(res);
    }
  };

  useEffect(() => {
    if (
      selectedIncidentResponsePlaybook &&
      selectedIncidentResponsePlaybook.length > 0
    ) {
      fetchPlaybookDetails();
    } else {
      setPlaybookDetails({});
    }
  }, [selectedIncidentResponsePlaybook]);

  return (
    <Fragment>
      <Grid sx={{ height: "100%", width: "100%" }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid xs={8}>
            <h3 style={{ fontWeight: "400" }}>
              {playbookDetails.playbookName}
            </h3>
          </Grid>
          <Grid>
            <Tooltip title="Download Playbook">
              <IconButton
                aria-label="download"
                disabled={
                  !playbookDetails.playbookID ||
                  !incidentResponsePlayBookAccess?.isDownload
                }
                onClick={() =>
                  downloadIncidentResponsePlaybook(
                    playbookDetails,
                    companyProfileID
                  )
                }
              >
                {React.createElement(PlanImport, {
                  opacity:
                    !playbookDetails.playbookID ||
                    !incidentResponsePlayBookAccess?.isDownload
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Playbook">
              <IconButton
                aria-label="edit"
                disabled={
                  !playbookDetails.playbookID ||
                  !incidentResponsePlayBookAccess?.isUpdate
                }
                onClick={handleEditPlaybook}
              >
                {React.createElement(EditPlan, {
                  opacity:
                    !playbookDetails.playbookID ||
                    !incidentResponsePlayBookAccess?.isUpdate
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Playbook">
              <IconButton
                aria-label="delete"
                disabled={
                  !playbookDetails.playbookID ||
                  !incidentResponsePlayBookAccess?.isDelete
                }
                onClick={confirmDelete}
              >
                {React.createElement(DeletePlan, {
                  opacity:
                    !playbookDetails.playbookID ||
                    !incidentResponsePlayBookAccess?.isDelete
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid>
          <h5
            style={{
              margin: "0.5rem 0",
              fontWeight: "400",
            }}
          >
            <RichTextBoxTabPanel
              readonly={true}
              tabs={tabDetalis}
              handleTabEditerChange={() => {}}
            />
          </h5>
        </Grid>
      </Grid>
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleDeletePlaybook}
          handleCancel={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
